import {Link} from 'react-router-dom'
const PageTitle = ({pageTitle, breadEnd, breadMid})=> {
return (
    <>
    <div className="page-title">
        <h1>{pageTitle}</h1>
        <p>
        <Link to="/"><i class="bi bi-house-fill"></i></Link>
        {/* <Link to="/"><i class="bi bi-arrow-right"></i> {breadMid}</Link> */}
        <i class="bi bi-arrow-right"></i> {breadEnd}</p>
         
    </div>
    </>
)
}
export default PageTitle